import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import './History.css'

import Season from './Season/Season'

import AllTimeStandings from './AllTimeStandings/AllTimeStandings'

import api from '../utils/api';

import seasonData2021Local from '../assets/seasonData/2021'
import seasonData2020Local from '../assets/seasonData/2020'
import seasonData2019Local from '../assets/seasonData/2019'
import seasonData2018Local from '../assets/seasonData/2018'
import seasonData2017Local from '../assets/seasonData/2017'
import Loader from '../lib/components/Loader';
import Payouts from './Payouts/Payouts';
import PlayoffDetailed from './PlayoffDetailed/PlayoffDetailed';

const History = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, updateLoading] = useState(true);
    
    const [seasonData2025, updateSeasonData2025] = useState({});
    const [seasonData2024, updateSeasonData2024] = useState({});
    const [seasonData2023, updateSeasonData2023] = useState({});
    const [seasonData2022, updateSeasonData2022] = useState({});
    const [seasonData2021, updateSeasonData2021] = useState({});
    const [seasonData2020, updateSeasonData2020] = useState({});
    const [seasonData2019, updateSeasonData2019] = useState({});
    const [seasonData2018, updateSeasonData2018] = useState({});
    const [seasonData2017, updateSeasonData2017] = useState({});
    
    const historyOptions = [
        { label: 'Overview', path: 'overview' },
        { label: '2025 Season + Draft', path: '2025' },
        { label: '2024 Season + Draft', path: '2024' },
        { label: '2023 Season + Draft', path: '2023' },
        { label: '2022 Season + Draft', path: '2022' },
        { label: '2021 Season + Draft', path: '2021' },
        { label: '2020 Season + Draft', path: '2020' },
        { label: '2019 Season + Draft', path: '2019' },
        { label: '2018 Season', path: '2018' },
        { label: '2017 Season + Draft', path: '2017' },
        { label: 'Advanced Playoffs', path: 'playoffs' },
        { label: 'Payout Summary', path: 'payouts' }
    ];

    const getPlayoffTeamData = (seasonData) => {
        return seasonData.slice(0, 6).reduce((acc, cur, index) => {
            acc[cur.manager] = {
                seed: index + 1
            };
            return acc;
        }, {});
    }

    useEffect(() => {
        updateLoading(true);
        const get2022Draft = api.get('/api/v1/draft?draftYear=2022');
        const get2023Draft = api.get('/api/v1/draft?draftYear=2023');
        const get2024Draft = api.get('/api/v1/draft?draftYear=2024');
        const get2025Draft = api.get('/api/v1/draft?draftYear=2025');
        const historyData = api.get('/api/v1/history/regSeason');
        const playoffData = api.get('/api/v1/history/playoffs');
        Promise.all([
            get2025Draft, get2024Draft, get2022Draft, get2023Draft, historyData, playoffData
        ]).then(([draft2025, draft2024, draft2022, draft2023, allSeasons, { data: allPlayoffs }]) => {
            updateSeasonData2025({
                draft: {
                    picks: draft2025.data.picks,
                    order: draft2025.data.order,
                    hasTimestamps: true
                },
                regSeason: {
                    standings: allSeasons.data[2025]
                },
                playoffs: {
                    teamData: getPlayoffTeamData(allSeasons.data[2025]),
                    gameData: allPlayoffs[2025]
                }
            })
            updateSeasonData2024({
                draft: {
                    picks: draft2024.data.picks,
                    order: draft2024.data.order,
                    hasTimestamps: true
                },
                regSeason: {
                    standings: allSeasons.data[2024]
                },
                playoffs: {
                    teamData: getPlayoffTeamData(allSeasons.data[2024]),
                    gameData: allPlayoffs[2024]
                }
            });
            updateSeasonData2023({
                draft: {
                    picks: draft2023.data.picks,
                    order: draft2023.data.order
                },
                regSeason: {
                    standings: allSeasons.data[2023]
                },
                playoffs: {
                    teamData: getPlayoffTeamData(allSeasons.data[2023]),
                    gameData: allPlayoffs[2023]
                }
            });
            updateSeasonData2022({
                draft: {
                    picks: draft2022.data.picks,
                    order: draft2022.data.order
                },
                regSeason: {
                    standings: allSeasons.data[2022]
                },
                playoffs: {
                    teamData: getPlayoffTeamData(allSeasons.data[2022]),
                    gameData: allPlayoffs[2022]
                }
            });
            updateSeasonData2021({
                draft: seasonData2021Local.draft,
                regSeason: {
                    standings: allSeasons.data[2021]
                },
                playoffs: {
                    teamData: getPlayoffTeamData(allSeasons.data[2021]),
                    gameData: allPlayoffs[2021]
                }
            });
            updateSeasonData2020({
                draft: seasonData2020Local.draft,
                regSeason: {
                    standings: allSeasons.data[2020]
                },
                playoffs: {
                    teamData: getPlayoffTeamData(allSeasons.data[2020]),
                    gameData: allPlayoffs[2020]
                }
            });
            updateSeasonData2019({
                draft: seasonData2019Local.draft,
                regSeason: {
                    standings: allSeasons.data[2019]
                },
                playoffs: {
                    teamData: getPlayoffTeamData(allSeasons.data[2019]),
                    gameData: allPlayoffs[2019]
                }
            });
            updateSeasonData2018({
                draft: seasonData2018Local.draft,
                regSeason: {
                    standings: allSeasons.data[2018]
                },
                playoffs: {
                    teamData: getPlayoffTeamData(allSeasons.data[2018]),
                    gameData: allPlayoffs[2018]
                }
            });
            updateSeasonData2017({
                draft: seasonData2017Local.draft,
                regSeason: {
                    standings: allSeasons.data[2017]
                },
                playoffs: {
                    teamData: getPlayoffTeamData(allSeasons.data[2017]),
                    gameData: allPlayoffs[2017]
                }
            });
            updateLoading(false);
        }).catch(err => {
            updateLoading(false);
            console.error(err);
        });

    }, []);

    const handleRouteChange = (path) => {
        navigate(`/history/${path}`);
    };

    const getCurrentPath = () => {
        const currentPath = location.pathname.replace('/history/', '').replace('/history', '');
        return currentPath || 'overview';
    };

    return (
        <div id="history" className="historyContainer">
            <h2>League History</h2>
            {loading 
                ?  <Loader/> 
                : 
                    <>
                        <div>
                            <select 
                                className='form-select' 
                                value={getCurrentPath()}
                                onChange={(e) => handleRouteChange(e.target.value)}
                            >
                                {historyOptions.map((option) => (
                                    <option key={option.path} value={option.path}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <Routes>
                                <Route path="/" element={<Navigate to="overview" replace />} />
                                <Route path="overview" element={
                                    <AllTimeStandings seasons={[
                                        seasonData2017, seasonData2018, seasonData2019, 
                                        seasonData2020, seasonData2021, seasonData2022, 
                                        seasonData2023, seasonData2024, seasonData2025
                                    ]}/>
                                } />
                                <Route path="2025" element={
                                    <Season season={seasonData2025} key="2025" yearName="2025" loadPayouts={true}/>
                                } />
                                <Route path="2024" element={
                                    <Season season={seasonData2024} key="2024" yearName="2024" loadPayouts={true}/>
                                } />
                                <Route path="2023" element={
                                    <Season season={seasonData2023} key="2023" yearName="2023" loadPayouts={true}/>
                                } />
                                <Route path="2022" element={
                                    <Season season={seasonData2022} key="2022" yearName="2022" loadPayouts={true}/>
                                } />
                                <Route path="2021" element={
                                    <Season season={seasonData2021} key="2021" yearName="2021"/>
                                } />
                                <Route path="2020" element={
                                    <Season season={seasonData2020} key="2020" yearName="2020"/>
                                } />
                                <Route path="2019" element={
                                    <Season season={seasonData2019} key="2019" yearName="2019"/>
                                } />
                                <Route path="2018" element={
                                    <Season season={seasonData2018} key="2018" yearName="2018"/>
                                } />
                                <Route path="2017" element={
                                    <Season season={seasonData2017} key="2017" yearName="2017"/>
                                } />
                                <Route path="playoffs" element={<PlayoffDetailed/>} />
                                <Route path="payouts" element={<Payouts/>} />
                            </Routes>
                        </div>
                    </>
            }
        </div>
    );
}

export default History;